(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/chat-host-schedule-section/assets/javascripts/chat-host-schedule-section.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/chat-host-schedule-section/assets/javascripts/chat-host-schedule-section.js');
"use strict";

var _chatHosts$, _chatHosts$2, _chatHosts$3, _chatHosts$4, _chatHosts$5, _chatHosts$6, _chatHosts$7, _chatHosts$8, _chatHosts$9, _chatHosts$0, _chatHosts$1, _chatHosts$10;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const ChatHostScheduleCard = svs.bingo_react.components.chatHostScheduleCard.ChatHostScheduleCard;
const Button = svs.ui.ReactButton;
const _React = React,
  useState = _React.useState;
const chatHosts = svs.bingo_react.data.chatHosts;

const mockData = [{
  gameId: '9136',
  gameTitle: 'Tusenlappen',
  hostName: (_chatHosts$ = chatHosts[0]) === null || _chatHosts$ === void 0 ? void 0 : _chatHosts$.name,
  hostImage: (_chatHosts$2 = chatHosts[0]) === null || _chatHosts$2 === void 0 ? void 0 : _chatHosts$2.profilePicture,
  startTime: Date.now() + 1000 * 30,
  endTime: new Date().getDate() + 1 
}, {
  gameId: '9137',
  gameTitle: 'Smörgåsgrillen',
  hostName: (_chatHosts$3 = chatHosts[1]) === null || _chatHosts$3 === void 0 ? void 0 : _chatHosts$3.name,
  hostImage: (_chatHosts$4 = chatHosts[1]) === null || _chatHosts$4 === void 0 ? void 0 : _chatHosts$4.profilePicture,
  startTime: Date.now() + 1000 * 120,
  endTime: new Date().getDate() + 1
}, {
  gameId: '9138',
  gameTitle: 'Fikastunden',
  hostName: (_chatHosts$5 = chatHosts[2]) === null || _chatHosts$5 === void 0 ? void 0 : _chatHosts$5.name,
  hostImage: (_chatHosts$6 = chatHosts[2]) === null || _chatHosts$6 === void 0 ? void 0 : _chatHosts$6.profilePicture,
  startTime: Date.now() + 1000 * 300,
  endTime: new Date().getDate() + 1
}, {
  gameId: '9139',
  gameTitle: 'Chartern',
  hostName: (_chatHosts$7 = chatHosts[0]) === null || _chatHosts$7 === void 0 ? void 0 : _chatHosts$7.name,
  hostImage: (_chatHosts$8 = chatHosts[0]) === null || _chatHosts$8 === void 0 ? void 0 : _chatHosts$8.profilePicture,
  startTime: Date.now() + 1000 * 400,
  endTime: new Date().getDate() + 2
}, {
  gameId: '9140',
  gameTitle: 'Kronjuvelen',
  hostName: (_chatHosts$9 = chatHosts[1]) === null || _chatHosts$9 === void 0 ? void 0 : _chatHosts$9.name,
  hostImage: (_chatHosts$0 = chatHosts[1]) === null || _chatHosts$0 === void 0 ? void 0 : _chatHosts$0.profilePicture,
  startTime: Date.now() + 1000 * 1000,
  endTime: new Date().getDate() + 1
}, {
  gameId: '9141',
  gameTitle: 'Midsommarbingo',
  hostName: (_chatHosts$1 = chatHosts[2]) === null || _chatHosts$1 === void 0 ? void 0 : _chatHosts$1.name,
  hostImage: (_chatHosts$10 = chatHosts[2]) === null || _chatHosts$10 === void 0 ? void 0 : _chatHosts$10.profilePicture,
  startTime: Date.now() + 1000 * 5000,
  endTime: new Date().getDate() + 1
}];
const ChatHostScheduleSection = () => {
  const _useState = useState(mockData),
    _useState2 = _slicedToArray(_useState, 2),
    chatHostSchedule = _useState2[0],
    setChatHostSchedule = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showMoreButton = _useState4[0],
    setShowMoreButton = _useState4[1];
  if (!chatHostSchedule.length) {
    return React.createElement("div", {
      className: "bingo-chat-host-schedule-no-data"
    }, "Just nu finns det inga chattv\xE4rdar tillg\xE4ngliga. V\xE4nligen kom tillbaka senare!");
  }
  return React.createElement("div", {
    className: "bingo-chat-host-schedule-section"
  }, chatHostSchedule.map((card, index) => {
    if (!showMoreButton && index >= 5) {
      return null;
    }
    return React.createElement(ChatHostScheduleCard, {
      card: card,
      key: card.gameId
    });
  }), chatHostSchedule.length > 5 && React.createElement("div", {
    className: "bingo-chat-host-schedule-section-button-wrapper"
  }, React.createElement(Button, {
    className: "bingo-chat-host-schedule-section-button-wrapper__show-more-btn",
    onClick: () => setShowMoreButton(!showMoreButton),
    transparent: true
  }, showMoreButton ? 'Visa färre' : 'Visa fler')));
};
setGlobal('svs.bingo_react.components.ChatHostScheduleSection', ChatHostScheduleSection);

 })(window);